export * as PosConfig from './PosConfig'
